import {apiTemplate} from "@/core/helpers/api.js";

export class Products {
  static async getProducts(data) {
    const userLocale = localStorage.getItem('awe-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `query {
        products ${data ? `(${data})` : ''} {
          edges {
            cursor
            node {
              uuid
              name
              price
              slug
              category {
                name
                slug
              }
              images {
                edges {
                  node {
                    image
                  }
                }
              }
              attributeGroups {
                edges {
                  node {
                    name
                    uuid
                    attributes {
                      name
                      uuid
                      values {
                        value
                        uuid
                      }
                    }
                  }
                }
              }
              feedbacks {
                edges {
                  node {
                    rating
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }`
    );

    return await response;
  }

  static async getProductBySlug(productSlug) {
    const userLocale = localStorage.getItem('awe-user-locale');

    const response = await apiTemplate(
      {
          "Content-Type": "application/json",
          "Accept-language": userLocale ? userLocale : 'en-gb'
      },
        `query {
           products (slug: "${productSlug}") {
            edges {
              node {
                uuid
                name
                price
                quantity
                description
                slug
                category {
                  name
                  slug
                }
                images {
                  edges {
                    node {
                      image
                    }
                  }
                }
                attributeGroups {
                  edges {
                    node {
                      name
                      uuid
                      attributes {
                        name
                        uuid
                        values {
                          value
                          uuid
                        }
                      }
                    }
                  }
                }
                feedbacks {
                  edges {
                    node {
                      rating
                    }
                  }
                }
              }
            }
          }
        }`
    );

    return await response;
  }
}